import * as ReasonsActions from '../../ng2/main/reasons/reasons.actions.ts';

module.exports = {
  controller: class HomeCtrl {
    static $inject =[
      '$ngRedux',
      'PatientAppContextService',
    ];

    constructor($ngRedux, PatientAppContextService) {
      this.$ngRedux = $ngRedux;
      this.PatientAppContextService = PatientAppContextService;
    }

    $onInit() {
      this.$ngRedux.dispatch(new ReasonsActions.UnsetCurrentReason());
      this.$ngRedux.dispatch(new ReasonsActions.ResetReasons());
      this.$ngRedux.dispatch(new ReasonsActions.ResetSelectedPatients());

      this.groupId = this.$ngRedux.getState().group.id;
      this.patient = this.PatientAppContextService.context.patient;
      this.authenticatedPatient = this.PatientAppContextService.context.authenticatedPatient;
    }
  },

  template: `<section class="home">
  <div class="content">
    <header class="infos">
      <div class="wrapper">
        <p class="greeting">{{ 'home.greeting' | translate:{patientFirstName: $ctrl.authenticatedPatient.firstName} }}</p>
        <span>
          <span class="list-ul-icon disabled"></span>
        <h1 class="title -main" ng-if="$ctrl.patient != $ctrl.authenticatedPatient" translate="home.title_with_name" translate-values="{name: ($ctrl.patient | patientName)}"></h1>
        <h1 class="title -main" ng-if="$ctrl.patient == $ctrl.authenticatedPatient" translate="home.title"></h1>
        </span>
      </div>
    </header>
    <div class="wrapper">
      <section class="upcoming">
        <upcoming-appointments></upcoming-appointments>
      </section>
      <section>
        <recall-list product="PATIENT_RECALL_LIST" product-group="::{id: $ctrl.groupId}"></recall-list>
      </section>
      <section class="appointment-requests" product="PATIENT_APPOINTMENT_REQUESTS" product-group="::{id: $ctrl.groupId}">
        <appointment-requests></appointment-requests>
      </section>
      <section class="cancelled-appointment-requests" product="PATIENT_APPOINTMENT_REQUESTS" product-group="::{id: $ctrl.groupId}">
        <cancelled-appointment-requests></cancelled-appointment-requests>
      </section>
      <section class="history -division">
        <h2 class="title -secondary">{{ 'home.history.title' | translate }}</h2>
        <historical-appointments></historical-appointments>
      </section>
    </div>
  </div>
</section>`,
};



// WEBPACK FOOTER //
// ./profile/components/home.js